export default {
  // Specific elements not related to adaptive cards
  baseZ: 9990,
  bar: {
    width: 90, // width has been deprecated as of 6.1.1
    heightDrawer: 45,
    widthWhenLargerThanSmall: 45,
    widthWhenLargerThanMedium: 90,
    breakpointToSmall: 775,
    breakpointToMedium: 992,
    backgroundColor: 'linear-gradient(to right, rgba(255,255,255,1) 0%,rgba(232,232,232,0.6) 100%)',
    drawerBackgroundColor: 'linear-gradient(to top, rgba(255,255,255,1) 0%,rgba(232,232,232,0.6) 100%)',
    withLabels: true,
    transitionLength: 300, // Deprecated as of 8.0.0
    arrowColor: '#4A90E2',
    iconMargin: 25,
    iconSeparatorColor: '#e8e8e8',
    iconSeparatorWidth: 1,
    icons: [
      {
        id: 'toknow',
        label: 'To Know',
        color: '#999999',
        selectedColor: '#4A90E2',
        backgroundColor: '#00FFFFFF',
        icon: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0MCAyOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDAgMjk7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojOTk5OTk5O30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjguMywxMWwzLjUtOC4zSDEwLjZWMS41YzAtMC43LTAuNS0xLjItMS4yLTEuMlM4LjIsMC44LDguMiwxLjV2MjZjMCwwLjcsMC41LDEuMiwxLjIsMS4yczEuMi0wLjUsMS4yLTEuMgoJCXYtOC4zaDIxLjJMMjguMywxMXoiLz4KPC9nPgo8L3N2Zz4K',
        selectedIcon:
          'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0MCAyOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDAgMjk7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojNEE5MEUyO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjguMywxMWwzLjUtOC4zSDEwLjZWMS41YzAtMC43LTAuNS0xLjItMS4yLTEuMlM4LjIsMC44LDguMiwxLjV2MjZjMCwwLjcsMC41LDEuMiwxLjIsMS4yczEuMi0wLjUsMS4yLTEuMgoJCXYtOC4zaDIxLjJMMjguMywxMXoiLz4KPC9nPgo8L3N2Zz4K',
        selectedBackgroundColor: '#00FFFFFF'
      },
      {
        id: 'todo',
        label: 'To Do',
        color: '#999999',
        selectedColor: '#4A90E2',
        backgroundColor: '#00FFFFFF',
        icon: 'data:image/svg+xml;base64,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',
        selectedIcon:
          'data:image/svg+xml;base64,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',
        selectedBackgroundColor: '#00FFFFFF'
      },
      {
        id: 'chat',
        label: 'Assistant',
        icon: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0MCAyOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDAgMjk7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojOTk5OTk5O30KPC9zdHlsZT4KPHRpdGxlPkFzayBJY29uPC90aXRsZT4KPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CjxnIGlkPSJQYWdlLTEiPgoJPGcgaWQ9IkFzay1JY29uIj4KCQk8cGF0aCBpZD0iU2hhcGUiIGNsYXNzPSJzdDAiIGQ9Ik0yOS4xLDJIMTAuOUM5LjYsMiw4LjgsMi4yLDguMywyLjZDNy44LDMsNy42LDMuOCw3LjYsNXYxNS4xYzAsMS4yLDAuMiwyLjEsMC42LDIuNQoJCQlzMS4yLDAuNiwyLjQsMC42aDQuNmwtMC4xLDMuNWMwLDAuMSwwLDAuMiwwLjEsMC4yczAuMiwwLDAuMywwbDQuMS0zLjdoMTAuMWMxLjMsMCwyLjEtMC4zLDIuNS0wLjhjMC40LTAuNSwwLjYtMS40LDAuNi0yLjdWNQoJCQljMC0xLjItMC4yLTIuMS0wLjctMi40QzMxLjMsMi4yLDMwLjQsMiwyOS4xLDJMMjkuMSwyeiBNMTUsMTIuOGMwLDAuNS0wLjIsMC45LTAuNSwxLjJjLTAuMywwLjMtMC43LDAuNS0xLjIsMC41CgkJCXMtMC44LTAuMi0xLjItMC41Yy0wLjMtMC4zLTAuNS0wLjctMC41LTEuMnMwLjItMC45LDAuNS0xLjJjMC4zLTAuMywwLjctMC41LDEuMi0wLjVzMC45LDAuMiwxLjIsMC41QzE0LjgsMTEuOSwxNSwxMi4zLDE1LDEyLjh6CgkJCSBNMjIsMTIuOGMwLDAuNS0wLjIsMC45LTAuNSwxLjJjLTAuMywwLjMtMC43LDAuNS0xLjIsMC41cy0wLjktMC4yLTEuMi0wLjVjLTAuMy0wLjMtMC41LTAuNy0wLjUtMS4yczAuMi0wLjksMC41LTEuMgoJCQljMC4zLTAuMywwLjctMC41LDEuMi0wLjVzMC45LDAuMiwxLjIsMC41QzIxLjgsMTEuOSwyMiwxMi4zLDIyLDEyLjh6IE0yOC45LDEyLjhjMCwwLjUtMC4yLDAuOS0wLjUsMS4yYy0wLjQsMC4zLTAuOCwwLjUtMS4yLDAuNQoJCQljLTAuNSwwLTAuOS0wLjItMS4yLTAuNWMtMC4zLTAuMy0wLjUtMC43LTAuNS0xLjJzMC4yLTAuOSwwLjUtMS4yYzAuMy0wLjMsMC43LTAuNSwxLjItMC41czAuOSwwLjIsMS4yLDAuNQoJCQlDMjguNywxMS45LDI4LjksMTIuMywyOC45LDEyLjh6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg==',
        color: '#999999',
        selectedColor: '#4A90E2',
        backgroundColor: '#00FFFFFF',
        selectedIcon:
          'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0MCAyOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDAgMjk7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojNEE5MEUyO30KPC9zdHlsZT4KPHRpdGxlPkFzayBJY29uPC90aXRsZT4KPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CjxnIGlkPSJQYWdlLTEiPgoJPGcgaWQ9IkFzay1JY29uIj4KCQk8cGF0aCBpZD0iU2hhcGUiIGNsYXNzPSJzdDAiIGQ9Ik0yOS4xLDJIMTAuOUM5LjYsMiw4LjgsMi4yLDguMywyLjZDNy44LDMsNy42LDMuOCw3LjYsNXYxNS4xYzAsMS4yLDAuMiwyLjEsMC42LDIuNQoJCQlzMS4yLDAuNiwyLjQsMC42aDQuNmwtMC4xLDMuNWMwLDAuMSwwLDAuMiwwLjEsMC4yczAuMiwwLDAuMywwbDQuMS0zLjdoMTAuMWMxLjMsMCwyLjEtMC4zLDIuNS0wLjhjMC40LTAuNSwwLjYtMS40LDAuNi0yLjdWNQoJCQljMC0xLjItMC4yLTIuMS0wLjctMi40QzMxLjMsMi4yLDMwLjQsMiwyOS4xLDJMMjkuMSwyeiBNMTUsMTIuOGMwLDAuNS0wLjIsMC45LTAuNSwxLjJjLTAuMywwLjMtMC43LDAuNS0xLjIsMC41CgkJCXMtMC44LTAuMi0xLjItMC41Yy0wLjMtMC4zLTAuNS0wLjctMC41LTEuMnMwLjItMC45LDAuNS0xLjJjMC4zLTAuMywwLjctMC41LDEuMi0wLjVzMC45LDAuMiwxLjIsMC41QzE0LjgsMTEuOSwxNSwxMi4zLDE1LDEyLjh6CgkJCSBNMjIsMTIuOGMwLDAuNS0wLjIsMC45LTAuNSwxLjJjLTAuMywwLjMtMC43LDAuNS0xLjIsMC41cy0wLjktMC4yLTEuMi0wLjVjLTAuMy0wLjMtMC41LTAuNy0wLjUtMS4yczAuMi0wLjksMC41LTEuMgoJCQljMC4zLTAuMywwLjctMC41LDEuMi0wLjVzMC45LDAuMiwxLjIsMC41QzIxLjgsMTEuOSwyMiwxMi4zLDIyLDEyLjh6IE0yOC45LDEyLjhjMCwwLjUtMC4yLDAuOS0wLjUsMS4yYy0wLjQsMC4zLTAuOCwwLjUtMS4yLDAuNQoJCQljLTAuNSwwLTAuOS0wLjItMS4yLTAuNWMtMC4zLTAuMy0wLjUtMC43LTAuNS0xLjJzMC4yLTAuOSwwLjUtMS4yYzAuMy0wLjMsMC43LTAuNSwxLjItMC41czAuOSwwLjIsMS4yLDAuNQoJCQlDMjguNywxMS45LDI4LjksMTIuMywyOC45LDEyLjh6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg==',
        selectedBackgroundColor: '#00FFFFFF',
        securityOptions: ['allow-forms', 'allow-popups'],
        url: 'https://workgridsoftware.workgrid.com/chat'
      },
      {
        id: 'apps',
        label: 'Apps',
        selectedColor: '#4A90E2',
        backgroundColor: '#00FFFFFF',
        icon: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0MCAyOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDAgMjk7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojOTk5OTk5O30KPC9zdHlsZT4KPHRpdGxlPmFwcHM8L3RpdGxlPgo8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KPGcgaWQ9IlBhZ2UtMSI+Cgk8ZyBpZD0iYXBwcyI+CgkJPGNpcmNsZSBpZD0iT3ZhbCIgY2xhc3M9InN0MCIgY3g9IjEwLjciIGN5PSI1LjIiIHI9IjMuMiIvPgoJCTxjaXJjbGUgaWQ9Ik92YWxfMV8iIGNsYXNzPSJzdDAiIGN4PSIyMCIgY3k9IjUuMiIgcj0iMy4yIi8+CgkJPGNpcmNsZSBpZD0iT3ZhbF8yXyIgY2xhc3M9InN0MCIgY3g9IjI5LjMiIGN5PSI1LjIiIHI9IjMuMiIvPgoJCTxjaXJjbGUgaWQ9Ik92YWxfM18iIGNsYXNzPSJzdDAiIGN4PSIxMC43IiBjeT0iMjMuOCIgcj0iMy4yIi8+CgkJPGNpcmNsZSBpZD0iT3ZhbF80XyIgY2xhc3M9InN0MCIgY3g9IjIwIiBjeT0iMjMuOCIgcj0iMy4yIi8+CgkJPGNpcmNsZSBpZD0iT3ZhbF81XyIgY2xhc3M9InN0MCIgY3g9IjI5LjMiIGN5PSIyMy44IiByPSIzLjIiLz4KCQk8Y2lyY2xlIGlkPSJPdmFsXzZfIiBjbGFzcz0ic3QwIiBjeD0iMTAuNyIgY3k9IjE0LjUiIHI9IjMuMiIvPgoJCTxjaXJjbGUgaWQ9Ik92YWxfN18iIGNsYXNzPSJzdDAiIGN4PSIyMCIgY3k9IjE0LjUiIHI9IjMuMiIvPgoJCTxjaXJjbGUgaWQ9Ik92YWxfOF8iIGNsYXNzPSJzdDAiIGN4PSIyOS4zIiBjeT0iMTQuNSIgcj0iMy4yIi8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg==',
        selectedIcon:
          'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0MCAyOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDAgMjk7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojNEE5MEUyO30KPC9zdHlsZT4KPHRpdGxlPmFwcHM8L3RpdGxlPgo8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KPGcgaWQ9IlBhZ2UtMSI+Cgk8ZyBpZD0iYXBwcyI+CgkJPGNpcmNsZSBpZD0iT3ZhbCIgY2xhc3M9InN0MCIgY3g9IjEwLjciIGN5PSI1LjIiIHI9IjMuMiIvPgoJCTxjaXJjbGUgaWQ9Ik92YWxfMV8iIGNsYXNzPSJzdDAiIGN4PSIyMCIgY3k9IjUuMiIgcj0iMy4yIi8+CgkJPGNpcmNsZSBpZD0iT3ZhbF8yXyIgY2xhc3M9InN0MCIgY3g9IjI5LjMiIGN5PSI1LjIiIHI9IjMuMiIvPgoJCTxjaXJjbGUgaWQ9Ik92YWxfM18iIGNsYXNzPSJzdDAiIGN4PSIxMC43IiBjeT0iMjMuOCIgcj0iMy4yIi8+CgkJPGNpcmNsZSBpZD0iT3ZhbF80XyIgY2xhc3M9InN0MCIgY3g9IjIwIiBjeT0iMjMuOCIgcj0iMy4yIi8+CgkJPGNpcmNsZSBpZD0iT3ZhbF81XyIgY2xhc3M9InN0MCIgY3g9IjI5LjMiIGN5PSIyMy44IiByPSIzLjIiLz4KCQk8Y2lyY2xlIGlkPSJPdmFsXzZfIiBjbGFzcz0ic3QwIiBjeD0iMTAuNyIgY3k9IjE0LjUiIHI9IjMuMiIvPgoJCTxjaXJjbGUgaWQ9Ik92YWxfN18iIGNsYXNzPSJzdDAiIGN4PSIyMCIgY3k9IjE0LjUiIHI9IjMuMiIvPgoJCTxjaXJjbGUgaWQ9Ik92YWxfOF8iIGNsYXNzPSJzdDAiIGN4PSIyOS4zIiBjeT0iMTQuNSIgcj0iMy4yIi8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg==',
        color: '#999999',
        selectedBackgroundColor: '#00FFFFFF'
      }
    ],
    commonIcons: {
      color: '#999999',
      selectedColor: '#4A90E2',
      backgroundColor: '#00FFFFFF',
      selectedBackgroundColor: '#00FFFFFF'
    }
  },
  // Summary panel
  summary: {
    width: 360,
    backgroundColor: '#efefef',
    transitionLength: 300,
    cardMargin: 16,
    numberOfCardsToFetch: 25
  },
  // Detail panel
  detail: {
    width: 360,
    backgroundColor: '#FFFFFF',
    transitionLength: 600,
    showArrow: true, // Deprecated as of 8.0.0
    showClose: true // Deprecated as of 8.0.0
  },
  apps: [],

  // These are common reused styles
  spacing: {
    small: 6,
    default: 12,
    medium: 15,
    large: 25,
    extraLarge: 35,
    padding: 20
  },
  fontFamily: 'Roboto, Arial, sans-serif',
  fontSizes: {
    small: 12,
    default: 13,
    medium: 16,
    large: 18,
    extraLarge: 30
  },
  fontLineHeight: {
    small: 1.2,
    default: 1.4,
    medium: 1.25,
    large: 1.2,
    extraLarge: 1.17
  },
  fontWeights: {
    lighter: 300,
    normal: 400,
    bolder: 700
  },
  priority: {
    informational: {
      color: '#4A90E2',
      accent: '#FFE4EDF8'
    },
    important: {
      color: '#F5A623',
      accent: '#F0ffead7'
    },
    critical: {
      color: '#E65757',
      accent: '#FFFBD3D8'
    }
  },
  colors: {
    primary: {
      normal: '#4A90E2',
      subtle: '#CC4A90E2'
    },
    secondary: {
      normal: '#BABABA',
      subtle: '#B2BABABA'
    },
    dark: {
      normal: '#1b1b1b',
      subtle: '#B21b1b1b'
    },
    medium: {
      normal: '#999999',
      subtle: '#B28f8f8f'
    },
    light: {
      normal: '#BABABA',
      subtle: '#B2BABABA'
    },
    accent: {
      normal: '#2E89FC',
      subtle: '#B22E89FC'
    },
    attention: {
      normal: '#c9282d',
      subtle: '#B2c9282d'
    },
    good: {
      normal: '#04A605',
      subtle: '#B204A605'
    },
    warning: {
      normal: '#FF9200',
      subtle: '#B2c00000'
    },
    link: {
      normal: '#4A90E2',
      subtle: '#CC4A90E2'
    }
  },
  containerSizes: {
    small: 40,
    medium: 80,
    large: 160
  },
  strongSeparation: {
    spacing: 2,
    lineThickness: 1,
    lineColor: '#6f1b1b1b'
  },
  separator: {
    lineThickness: 1,
    lineColor: '#c8c8c8FF'
  },

  // From this point on, these describe actual elements
  adaptiveCard: {
    borderRadius: 3,
    backgroundColor: '#FFFFFFFF',
    shadow: {
      blur: 8,
      spread: 0,
      offsetX: 0,
      offsetY: 0,
      color: '#9b969696'
    }
  },
  newFlag: {
    iconColor: '#6C953C',
    color: '#FFFFFFFF',
    shadow: {
      blur: 2,
      spread: 2,
      offsetX: 2,
      offsetY: 2,
      color: '#9b000000'
    }
  },
  dueDate: {
    iconColor: 'light',
    color: 'light',
    size: 'default',
    weight: 'bolder'
  },
  actions: {
    maxActions: 4, // Deprecated
    spacing: 'medium',
    separator: true,
    buttonSpacing: 'medium',
    showCard: {
      actionMode: 'popup',
      style: 'default'
    },
    actionAlignment: 'stretch',
    types: {
      primary: {
        backgroundColor: 'primary',
        color: '#FFFFFF'
      },
      secondary: {
        backgroundColor: 'secondary',
        color: '#FFFFFF'
      },
      attention: {
        backgroundColor: 'attention',
        color: '#FFFFFF'
      },
      good: {
        backgroundColor: 'good',
        color: '#FFFFFF'
      },
      warning: {
        backgroundColor: 'warning',
        color: '#FFFFFF'
      },
      link: {
        backgroundColor: 'link',
        color: '#FFFFFF'
      }
    }
  },
  textBlock: {
    color: 'medium',
    fontSize: 'medium'
  },
  image: {
    size: 'medium'
  },
  imageSet: {
    imageSize: 'medium',
    maxImageHeight: 100
  },
  factSet: {
    title: {
      color: 'medium',
      weight: 'bolder',
      wrap: true, // Deprecated as of 8.0.5
      maxWidth: 150 // Deprecated as of 8.0.5
    },
    value: {
      color: 'medium',
      weight: 'normal',
      wrap: true
    }
  },
  input: {
    backgroundColor: '#FFf5f8fa',
    borderColor: '#FFCBD6E2',
    labelColor: 'dark',
    placeholderColor: '#FF8498b6',
    color: 'dark',
    size: 'default'
  },
  actionButtons: {
    borderRadius: 2,
    textTransform: 'uppercase' // Also supports 'sentence-case'
  },
  range: {
    selectedColor: '#FF4A90E2',
    thumbColor: '#FF4A90E2',
    trackColor: '#FFBABABA'
  },
  badge: {
    borderColor: 'transparent',
    backgroundColor: 'attention',
    color: '#FFFFFFFF'
  },
  columnSet: {},
  column: {},
  choiceSet: {},
  notificator: {
    // Colors
    wgColorLow: '#4A90E2',
    wgColorModerate: '#F5A623',
    wgColorHigh: '#C9282D',
    wgColorNew: '#509900',
    wgColorPrimary: '#4A90E2',
    wgColorSecondary: '#C2C2C2',
    wgColorLinks: '#4A90E2',
    wgColorDarker: '#002663',
    wgColorDark: '#4B4B4B',
    wgColorMedium: '#999999',
    wgColorLight: '#BABABA',
    wgColorLightest: '#F3F3F3',
    wgColorWhite: '#FFFFFF',

    // Text Sizes
    wgTextGiant: '3.42rem',
    wgTextHuge: '2.14rem',
    wgTextBigger: '1.29rem',
    wgTextBig: '1.14rem',
    wgTextNormal: '1rem',
    wgTextSmall: '0.93rem',
    wgTextSmaller: '0.86rem',
    wgTextTiny: '0.75rem',
    wgTextMiniscule: '0.65rem'
  }
}
